import { render, staticRenderFns } from "./CaseDraft.vue?vue&type=template&id=5ddc27e6&"
import script from "./CaseDraft.vue?vue&type=script&lang=js&"
export * from "./CaseDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports